import { render, staticRenderFns } from "./ProviderTabs.vue?vue&type=template&id=3a16ce66"
import script from "./ProviderTabs.vue?vue&type=script&lang=js"
export * from "./ProviderTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports